import { render, staticRenderFns } from "./ToxprintsView.vue?vue&type=template&id=3fee4544&scoped=true"
import script from "./ToxprintsView.vue?vue&type=script&lang=js"
export * from "./ToxprintsView.vue?vue&type=script&lang=js"
import style0 from "./ToxprintsView.vue?vue&type=style&index=0&id=3fee4544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee4544",
  null
  
)

export default component.exports